import type { LeaderboardRow } from '../types';

export function getApproacherPosition(
  leaderboard: LeaderboardRow[],
  approacherId: string
): number {
  const sorted = [...leaderboard].sort(
    (a, b) => b.creatorCount - a.creatorCount
  );
  const idx = sorted.findIndex((r) => r.id === approacherId);
  return idx === -1 ? 0 : idx + 1;
}
